import { QuestionDetailsHeaderRequestJSON } from "./../questionPage/Question-Details-Header-Request.JSON";
import { QuestionCardRequestJSON } from "./../questionPage/Question-Card-Request.JSON";
import { SurveyDeployerWCPageRequestJSON } from "./../RequestTOJSON/Survey-Deployer-WC-Page-Request.JSON";

export class QuestionPageDetailsRequestJSON {
    surveyUserGeneratedID:Number;
    surveyID: Number;
    questionDetailsHeaderResponseJSON: QuestionDetailsHeaderRequestJSON;
    questionCardResponseJSONList: QuestionCardRequestJSON[];
    surveyDeployerWCPageRequestJSON: SurveyDeployerWCPageRequestJSON;

    constructor() {
        this.questionDetailsHeaderResponseJSON = new QuestionDetailsHeaderRequestJSON;
        this.questionCardResponseJSONList = new Array<QuestionCardRequestJSON>();
    }
}